import { Headset } from 'lucide-react';
import { Link } from 'wouter';
import { SidebarMenuButton, SidebarMenuItem } from '@/components/ui/sidebar';

/** The Customer Service entry: every logged-in user has the team pages. */
export function CsSidebarSection({ location }: { location: string }) {
  return (
    <>
      <SidebarMenuItem className="pt-4">
        <div className="mb-2 px-3 text-xs font-semibold text-byacre-royal-blue">Customer Service</div>
      </SidebarMenuItem>
      <SidebarMenuItem>
        <SidebarMenuButton asChild isActive={location === '/customer-service' || location.startsWith('/customer-service/')}>
          <Link href="/customer-service">
            <Headset className="h-4 w-4" />
            <span>CS Dashboard</span>
          </Link>
        </SidebarMenuButton>
      </SidebarMenuItem>
    </>
  );
}
